<template>
  <div class="headWarp">
    <div class="nav_cont cl">
      <div class="logo z">
        <router-link :to="{ path: '/', query: { language: lang } }">
          <img :src="logo" alt="" />
        </router-link>
      </div>
      <div class="Mmenu z" @click="MmenuShow = true">
        <i class="iconfont iconcaidan"></i>
      </div>
      <div class="head_main y">
        <div class="cl">
          <div class="langWarp y" :class="[langShow ? 'on' : '']">
            <div class="langTop" @click="langisShow()" ref="lang">
              <span> {{ langTxt }} </span
              ><i class="iconfont iconangle-down"></i>
            </div>
            <div class="langList">
              <ul>
                <li
                  v-for="(item, index) in langList"
                  @click="langSelect(index, item)"
                  :class="[index == isactive ? 'active' : '']"
                  :key="index"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
          <div class="menuList y" :class="[MmenuShow ? 'show' : '']">
            <div class="Mtop">
              <div class="close" @click="MmenuShow = false">
                <i class="iconfont iconguanbi"></i>
              </div>
              <router-link :to="{ path: '/', query: { language: lang } }">
                <img src="../assets/logo.png" alt="" />
              </router-link>
            </div>
            <div class="item">
              <router-link :to="{ path: '/', query: { language: lang } }">{{
                $t("header_menu.index")
              }}</router-link>
            </div>
            <div class="item">
              <router-link :to="{ path: '/game', query: { language: lang } }">{{
                $t("header_menu.game")
              }}</router-link>
            </div>
            <div class="item">
              <router-link :to="{ path: '/news', query: { language: lang } }">{{
                $t("header_menu.news")
              }}</router-link>
            </div>
            <div class="item">
              <router-link
                :to="{ path: '/about', query: { language: lang } }"
                >{{ $t("header_menu.about") }}</router-link
              >
            </div>
            <div class="item">
              <router-link
                v-if="lang != 'zh'"
                :to="{ path: '/join', query: { language: lang } }"
              >
                {{ $t("header_menu.JoinUs") }}
              </router-link>
              <a
                href="https://app.mokahr.com/apply/playcrab/24831#/?anchorName=default_banner&sourceToken="
                target="blank_"
                v-else-if="lang == 'zh'"
                >{{ $t("header_menu.JoinUs") }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLang } from "@/common/api.js";
export default {
  name: "Head",
  components: {
    getLang,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      logo: require("../assets/logo.png"),
      lang: this.$route.query.language || "zh",
      langTxt: "中文",
      langList: [],
      langLists: [
        { name: "中文", lang: "zh" },
        { name: "English", lang: "en" },
        { name: "한국어", lang: "kr" },
        { name: "日本語", lang: "jp" },
      ],
      isactive: 0,
      langShow: false,
      MmenuShow: false,
      newShow: true,
    };
  },
  beforeMount() {
    // 在页面挂载前就发起请求
    this.getLanguge();
    //外文隐藏新闻
    if (this.lang != "zh") {
      this.logo = require("../assets/logox.png");
      this.newShow = false;
    } else {
      this.logo = require("../assets/logo.png");
      this.newShow = true;
    }
  },
  created() {
    let that = this;
    this.$i18n.locale = this.lang;
    this.langLists.filter(function (item) {
      if (item.lang == that.lang) {
        that.langTxt = item.name;
      }
    });
  },
  mounted() {},
  methods: {
    getLanguge() {
      let that = this;
      getLang({}).then((res) => {
        if (res.status == 200) {
          let Data = res.data.data;
          that.langList = Data;
        } else {
          console.log(res.statusText);
        }
      });
    },
    //选中状态
    langSelect(index, item) {
      //判断当前路由为joinus123
      if (this.$route.name == "Join" && item.lang == "zh") {
        window.open(
          "https://app.mokahr.com/apply/playcrab/24831#/?anchorName=default_banner&sourceToken="
        );
        return false;
      }
      this.lang = item.lang;
      this.isactive = index;
      this.langTxt = item.name;
      this.$i18n.locale = item.lang;
      //   this.$store.commit("SET_LANG", item.lang);
      this.$emit("langChange", item.lang);
      //外文隐藏新闻
      if (this.lang != "zh") {
        this.newShow = false;
        this.logo = require("../assets/logox.png");
      } else {
        this.newShow = true;
        this.logo = require("../assets/logo.png");
      }
      //切换地址栏参数
      //获取当前路由地址
      let router_path = this.$route.path;
      if (router_path == "/newsDetail") {
        //如果是详情页跳转首页
        this.$router.push({
          path: "/news",
          query: { language: this.lang },
        });
      } else {
        this.$router.push({
          path: router_path,
          query: { language: this.lang },
        });
      }
    },
    //下拉是否显示
    langisShow() {
      this.langShow = !this.langShow;
    },
  },
  mounted() {
    document.addEventListener("click", (e) => {
      if (this.$refs.lang != null) {
        if (!this.$refs.lang.contains(e.target)) {
          this.langShow = false; //点击其他区域关闭
        } else {
          this.langShow = true;
        }
      }
    });
  },
  computed: {},
};
</script>
<style scoped >
</style>
















// WEBPACK FOOTER //
// src/components/head.vue